import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import { goToPrevStep } from '~/src/features/full-buy/store/actions/goToPrevStep';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const skipSubscriptionsStep = () => (dispatch: TAppThunkDispatch, getState: TGetState) => {
    const state = getState();
    const tariff = selectCurrentTariff(state);
    const { stepIndex, prevStepIndex } = state.fullBuy;

    const isBackward = prevStepIndex > stepIndex;
    // @todo replace to a selector. Simplify condition by `!!tariff?.subscriptions Summary?.length && !!tariff?.sale Package Links?.length;`
    const hasSubscriptions = (tariff?.subscriptionsSummary && tariff?.subscriptionsSummary?.length > 0) && (tariff?.salePackageLinks && tariff?.salePackageLinks?.length > 0);

    if (!hasSubscriptions) {
        dispatch(isBackward ? goToPrevStep() : goToNextStep());
    }
};

export default skipSubscriptionsStep;
